import LegalShell from "@/components/site/LegalShell";

const sections = [
  {
    h: "1. Nature of Services",
    body: [
      "We provide independent, owner-side property consulting exclusively for owners of prime UK real estate. Services include:",
    ],
    list: [
      "Property Advisory (yield & compliance blueprints).",
      "Refurbishment & Vendor Oversight.",
      "Operator Selection & Stewardship.",
    ],
    after:
      "We act as advisors only. We do not sell, let, manage, or take custody of properties or funds. All work is performed under written mandates with fixed or performance-linked fees. Advice is data-driven and confidential. Engagements are fee-for-service with no commissions from third parties.",
  },
  {
    h: "2. No Agency or Fiduciary Relationship Beyond Mandate",
    body: [
      "We are not your agent, broker, or property manager. Any formal engagement is defined solely by a written mandate. Nothing on the Site creates a client relationship until a mandate is executed.",
    ],
  },
  {
    h: "3. Site Use",
    body: ["You agree to use the Site lawfully and not to:"],
    list: [
      "Interfere with the Site's operation.",
      "Attempt unauthorized access.",
      "Transmit harmful content.",
      "Misrepresent affiliation with us.",
    ],
    after:
      "The Site content is for general information. It does not constitute professional advice until provided under a specific mandate.",
  },
  {
    h: "4. Consultations and Engagements",
    body: [
      "Introductory conversations are confidential and carry no fee. Formal services require a written mandate specifying scope, fees, deliverables, and terms. Fees are as outlined in proposals (e.g., fixed fees for advisory, percentage of contract value for oversight, retainers for stewardship). Payment terms will be stated in the mandate. You retain full custody of assets and funds.",
    ],
  },
  {
    h: "5. Confidentiality",
    body: [
      "We treat all client information and discussions as confidential. You agree to treat any non-public information we provide similarly. This obligation survives termination of any engagement.",
    ],
  },
  {
    h: "6. Intellectual Property",
    body: [
      "All Site content, methodologies, reports, and materials we create remain our intellectual property unless otherwise agreed in writing. You may use deliverables solely for the purpose of the specific engagement.",
    ],
  },
  {
    h: "7. Disclaimers",
    list: [
      "Advice is based on information available at the time and micro-market data. Outcomes (including yield performance) are not guaranteed.",
      "We are not responsible for the actions of third-party contractors, operators, agents, or borough regulations.",
      "The Site is provided “as is.” We disclaim warranties to the fullest extent permitted by law.",
      "Past case studies or client comments are illustrative only.",
    ],
  },
  {
    h: "8. Limitation of Liability",
    body: [
      "To the maximum extent permitted by applicable law, our total liability arising from the Site or services shall not exceed the fees paid by you for the specific engagement giving rise to the claim. We are not liable for indirect, incidental, consequential, or lost-profit damages. This limitation applies regardless of the form of action.",
    ],
  },
  {
    h: "9. Indemnification",
    body: [
      "You agree to indemnify and hold us harmless from claims arising from your use of the Site, your properties, or your breach of these Terms, except to the extent caused by our willful misconduct.",
    ],
  },
  {
    h: "10. Governing Law and Disputes",
    body: [
      "These Terms are governed by the laws of the State of Wyoming, USA, without regard to conflict-of-law principles. Any disputes shall be resolved in the state or federal courts located in Wyoming, or as otherwise agreed in a specific mandate. For clients subject to mandatory consumer protections in their jurisdiction, those protections remain available.",
    ],
  },
  {
    h: "11. Termination",
    body: [
      "We may suspend or terminate access to the Site or decline engagements at our discretion. Mandates may be terminated according to their specific terms.",
    ],
  },
  {
    h: "12. Changes",
    body: [
      "We may update these Terms. Continued use after updates constitutes acceptance. Material changes will be noted with an updated date.",
    ],
  },
  {
    h: "13. Contact",
    body: [
      "I Putu Adi Semarada LLC · 30 N Gould St Ste R, Sheridan, WY 82801, USA",
      "Email: info@adi-semaradana.com · Phone: +1 888 557 6994",
      "Registered in Wyoming, USA. Independent · Fee-for-service · Confidential.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalShell
      testId="terms-page"
      title="Terms & Conditions"
      updated="November 5, 2026"
      intro="These Terms and Conditions (“Terms”) govern your use of the website www.adi-semaradana.com (the “Site”) and any advisory services provided by I Putu Adi Semarada LLC (“we,” “us,” “our,” or “the Company”), a Wyoming, USA limited liability company. By accessing the Site or engaging our services, you agree to these Terms. If you do not agree, do not use the Site or services."
      sections={sections}
    />
  );
}
